// Copyright (c) 2022 by Move Closer

export const HASH_PRODUCT = '###'
